import React from "react";
import { useParams } from "react-router-dom";
import { filterList } from "../utils/utils";
import { Typography } from "@mui/material";
import FmdGoodRoundedIcon from '@mui/icons-material/FmdGoodRounded';

import HomeSearch from "../Components/HomeSearch";
import WhiteCard from "../Components/WhiteBox";


import { useNavigate } from "react-router-dom";

export default function Search() {
  let params = useParams()
  const navigate = useNavigate()

  const [list, setList] = React.useState(null)
  
  if(!list)
    filterList(params.cityName).then(l => setList({ list: l, update: params.cityName }))
  
  if (list && list.update !== params.cityName) {
    filterList(params.cityName).then(l => setList({ list: l, update: params.cityName }))
  }

  const handleCitySelected = (city) => {
    navigate('/city/' + city.id)
  }


  return (
    <div className="container">
      <Typography variant="h5" gutterBottom component="div">
        Risultati di ricerca
      </Typography>
      
      <HomeSearch dfSearch={ params.cityName }/>
      <hr />

      <div style={{alignItems:'center', textAlign:'center', padding:'10px 15px'}}>
        {
          list ? 
            <>
              {
                list.list.map(c => 
                  <WhiteCard key={c.id} id={c} content={<p>{ c.name }</p>} icon={<FmdGoodRoundedIcon />} selected={handleCitySelected} ></WhiteCard>
                )
              }
            </>
            :
          <></>
        }
        {/* {
          l.map(c => 
            <WhiteCard key={c.id} id={c} content={<p>{ c.name }</p>} icon={<FmdGoodRoundedIcon />} selected={handleCitySelected} ></WhiteCard>
          )
        } */}
      </div>
      <div style={{display: 'block', height:'70px'}}></div>
    </div>
  )
}